// import ApiService from '@/helpers/api.service';
// const API = new ApiService();
import ApiService2 from "@/helpers/api.service.ext";
const API2 = new ApiService2();
const ERENTA_ENDPOINT = "/kantoads/erenta";
const KANTOADS_CASHOUT_ENDPOINT = '/kantoads/cashout';

export const state = {
  eRentaFunds: 0,
  eRentaTxn: [],
  eRentaTxnPageInfo: {
    total: 0,
  },
  eRentaDailyIncoming: 0,
  eRentaDailyOutgoing: 0,
  eRentaMonthlyIncoming: 0,
  eRentaMonthlyOutgoing: 0,
  errors: null,
};

export const mutations = {
  UPDATE_ERENTA_WALLET(state, list) {
    state.eRentaFunds = list;
  },
  UPDATE_ERENTA_TXN(state, list) {
    state.eRentaTxn = list;
  },
  UPDATE_ERENTA_TXN_PAGE_INFO(state, total) {
    state.eRentaTxnPageInfo.total = total;
  },
  UPDATE_ERENTA_INCOME(state, data) {
    state.eRentaDailyIncoming = data.dailyIncoming;
    state.eRentaDailyOutgoing = data.dailyOutgoing;
    state.eRentaMonthlyIncoming = data.monthlyIncoming;
    state.eRentaMonthlyOutgoing = data.monthlyOutgoing;
  },
  SET_PROD_ERRORS(state, errors) {
    state.errors = errors;
  },
};

export const actions = {
  getErentaFunds(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ERENTA_ENDPOINT}/get-erenta-funds`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ERENTA_WALLET", data.message.total_fund);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  getErentaIncome(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ERENTA_ENDPOINT}/get-erenta-income`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ERENTA_INCOME", data.message);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
  getErentaTxn(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${KANTOADS_CASHOUT_ENDPOINT}/get-cashouts`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ERENTA_TXN", data.message.rows);
          context.commit("UPDATE_ERENTA_TXN_PAGE_INFO", data.message.pageInfo.total);
          resolve();
        })
        .catch(({ response }) => {
          context.commit("SET_PROD_ERRORS", response.message);
          reject();
        });
    });
  },
};

